export const EVENT_ON_CART_UPDATE = 'onCartUpdate';
export const EVENT_ON_FAV_UPDATE = 'onFavUpdate';
